// services/index.ts

import { defineService, SERVICE_DEFINITIONS } from '@/services/_base/defineService'
import type { Product } from '@farmfree/common/types/product/product'
import type { Category } from '@farmfree/common/types/category/category'
import type { Option } from '@farmfree/common/types/option/option'
import type { OptionGroup } from '@farmfree/common/types/option/optionGroup'
import type { MarketplaceAccount } from '@farmfree/common/types/commerce/marketplaceAccount'
import type { CourierSaasAccount } from '@farmfree/common/types/courierSaas/courierSaasAccount'
import type { SmsTemplate } from '@farmfree/common/types/template/smsTemplate'
import type { BankSettings } from '@farmfree/common/types/bank/bankTransaction'
import type { ManualInput } from '@/shared-types/message/manualInput'
import type { OrderPen } from '@farmfree/common/types/order/orderPen'
import type { Consignor } from '@farmfree/common/types/consignment/consignor'
import type { ConsignmentBatch } from '@farmfree/common/types/consignment/consignmentBatch'
import type { SenderPreset } from '@farmfree/common/types/consignment/senderPreset'
import type { SplitRegionItem } from '@farmfree/common/types/message/splitRegion'

export const createProductService = defineService<Product>(SERVICE_DEFINITIONS.product)
export const createCategoryService = defineService<Category>(SERVICE_DEFINITIONS.category)
export const createOptionService = defineService<Option>(SERVICE_DEFINITIONS.option)
export const createOptionGroupService = defineService<OptionGroup>(SERVICE_DEFINITIONS.optionGroup)
export const createMarketplaceAccountService = defineService<MarketplaceAccount>(
  SERVICE_DEFINITIONS.marketplace
)
export const createCourierSaasService = defineService<CourierSaasAccount>(
  SERVICE_DEFINITIONS.courierSaas
)
export const createSmsTemplateService = defineService<SmsTemplate>(SERVICE_DEFINITIONS.smsTemplate)
export const createBankSettingsService = defineService<BankSettings>(
  SERVICE_DEFINITIONS.bankSettings
)
export const createManualInputService = defineService<ManualInput>(SERVICE_DEFINITIONS.manualInput)
export const createActiveOrderService = defineService<OrderPen>(SERVICE_DEFINITIONS.activeOrder)
export const createConsignorService = defineService<Consignor>(SERVICE_DEFINITIONS.consignor)
export const createConsignmentBatchService = defineService<ConsignmentBatch>(
  SERVICE_DEFINITIONS.consignmentBatch
)
export const createSenderPresetService = defineService<SenderPreset>(
  SERVICE_DEFINITIONS.senderPreset
)
export const createSplitRegionService = defineService<SplitRegionItem>(
  SERVICE_DEFINITIONS.splitRegion
)

// 은행 거래내역 서비스는 별도 파일에서 export
export { createBankTransactionService } from '@/services/bank/bankTransactionService'

// 택배 SaaS 특수 기능 서비스는 별도 파일에서 export
export { createCourierSaasFunctionsService } from '@/services/courierSaas/courierSaasFunctionsService'
